import m from "../../es2015/themes/amchartsdark";
window.am4themes_amchartsdark = m;


//////////////////
// WEBPACK FOOTER
// ./themes/amchartsdark.js
// module id = null
// module chunks = 